import type { FrontendModule } from '../core/modules/types';
import wallbox from './wallbox/module';
import thomann from './thomann/module';
import inventar from './inventar/module';
import retreat from './retreat/module';

/**
 * All frontend modules in this build. Which of them are used is decided per
 * instance (instances/<INSTANCE>/instance.yaml → GET /api/instance).
 */
export const moduleCatalog: FrontendModule[] = [wallbox, thomann, inventar, retreat];
